import { Component, Input, type OnChanges, type SimpleChanges, type OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { AccountDetail } from '../../models/account-detail';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-billing-settings',
  imports: [MatCardModule, RouterModule],
  templateUrl: './billing-settings.component.html',
  styleUrl: './billing-settings.component.scss',
})
export class BillingSettingsComponent implements OnInit, OnChanges {
  @Input() data: any = null;
  @Input() accountDetail: AccountDetail = new AccountDetail();
  billingSettings: any[] = [];

  ngOnInit(): void {
    // nothing here because change gets called before init somehow?
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.data = JSON.parse(JSON.stringify(changes['data'].currentValue));
    this.billingSettings = [];
    this.setAutopaySection();
    this.setWalletSection();
    this.setBillDeliverySection();
    this.setAlertsSection();
  }

  /**
   * Section for billing settings logic
   */

  setAutopaySection(): void {
    const copy = JSON.parse(JSON.stringify(this.data));
    if (this.accountDetail.IsAutoPay) {
      const change = copy.billingSettings.find((setting: any) => {
        return setting.setting.builderRefName === 'Autopay Change';
      })?.setting;

      if (change) {
        change.linkUrl = change.linkUrl.url;
        this.billingSettings.push(change);
      }

      const cancel = copy.billingSettings.find((setting: any) => {
        return setting.setting.builderRefName === 'Autopay Cancel';
      })?.setting;

      if (cancel) {
        cancel.linkUrl = cancel.linkUrl.url;
        this.billingSettings.push(cancel);
      }
    } else {
      const enroll = copy.billingSettings.find((setting: any) => {
        return setting.setting.builderRefName === 'Autopay Enroll';
      })?.setting;

      if (enroll) {
        enroll.linkUrl = enroll.linkUrl.url;
        this.billingSettings.push(enroll);
      }
    }
  }

  setWalletSection(): void {
    const copy = JSON.parse(JSON.stringify(this.data));
    const wallet = copy.billingSettings.find((setting: any) => {
      if (copy.showWallet) {
        return setting.setting.builderRefName === 'Wallet Edit';
      } else {
        return setting.setting.builderRefName === 'Wallet Add';
      }
    })?.setting;

    if (wallet) {
      wallet.linkUrl = wallet.linkUrl.url;
      this.billingSettings.push(wallet);
    }
  }

  setBillDeliverySection(): void {
    const copy = JSON.parse(JSON.stringify(this.data));
    const bill = copy.billingSettings.find((setting: any) => {
      if (this.accountDetail.IsPaperlessBilling) {
        return setting.setting.builderRefName === 'Bill Paperless';
      } else {
        return setting.setting.builderRefName === 'Bill Paper';
      }
    })?.setting;

    if (bill) {
      bill.linkUrl = bill.linkUrl.url;
      this.billingSettings.push(bill);
    }
  }

  setAlertsSection(): void {
    const copy = JSON.parse(JSON.stringify(this.data));
    if (
      this.accountDetail.PrimaryAccountHolder &&
      (this.accountDetail.CustomerClass === 'RES' || this.accountDetail.CustomerClass === 'SMLCOM')
    ) {
      const alerts = copy.billingSettings.find((setting: any) => {
        return setting.setting.builderRefName === 'Alerts Change';
      })?.setting;

      if (alerts) {
        alerts.linkUrl = alerts.linkUrl.url;
        this.billingSettings.push(alerts);
      }
    }
  }
}
